export default __webpack_public_path__ + "static/media/catlike_1.e938c332.ogv";